<template>
  <slot>
    <div class="govuk-form-group required" :id="identifier" v-show="!state.hidden">
      <label class="govuk-label" :for="controlId" v-show="!state.hiddenLabel" v-html="displayName"> </label>
      <span :id="titleId" class="govuk-title" v-html="displayTitle"></span>

      <div :class="displayHintClasses" v-if="displayHint" v-on:click="toggleHintSection" v-html="displayHintText"></div>
      <div :id="hintId" class="govuk-hint" v-show="!state.hiddenHint" v-html="displayHint"></div>

      <span :id="errorId" class="govuk-error-message">
        <ul v-if="currentErrors.length > 0">
          <li v-for="(errorMessage, errIndex) in currentErrors" v-bind:key="errIndex">
            {{ errorMessage.message }}
          </li>
        </ul>
      </span>
      <input :id="controlId" type="text" :name="controlId" title="" :aria-describedby="hintId" class="govuk-input" />
    </div>
  </slot>
</template>
<script lang="ts" src="@/library/templates/default/controls/DecimalBox.ts"></script>
